import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { errorInput } from '../../components/helpers';
import {
  useRecaptchaToken,
  isCaptchaRequired,
  RECAPTCHA_SECURITY_ERROR,
} from '../../components/helpers/recaptchaUtils';
import { Button } from 'semantic-ui-react';
import groupService from '../../services/api/groupService';
import Swal from 'sweetalert2';
import {
  RelacionesSanasLeaderCompText,
  RelacionesSanasCompText,
  ParaSiempreCompText,
  ParaSiempreLeaderCompText,
  WeddingProjectLeaderCompText,
  WeddingProjectCompText,
} from '../../containers/groups/compliances/ComplianceTexts';
import GroupsComplianceForm from '../../containers/groups/compliances/GroupsComplianceForm';
import { habeasData } from '../../components/helpers/habeasData';
import { VolunteerRegistrationContainer } from 'src/assets/styles/components/volunteerReg';

const GroupCompliance = (props) => {
  const [inputs, setInputs] = React.useState({});
  const [errorInputs, set_errorInputs] = React.useState({});
  const [sending, set_sending] = React.useState(false);
  const getCaptchaToken = useRecaptchaToken('compliance');
  const captchaRequired = isCaptchaRequired();

  let document = {
    liderproyectomatrimonio: {
      type: 'couple',
      component: WeddingProjectLeaderCompText,
    },
    proyectomatrimonio: { type: 'couple', component: WeddingProjectCompText },
    liderparasiempre: {
      type: 'couple',
      component: ParaSiempreLeaderCompText,
    },
    parasiempre: { type: 'couple', component: ParaSiempreCompText },
    liderrelacionessanas: {
      type: 'single',
      component: RelacionesSanasLeaderCompText,
    },
    relacionessanas: { type: 'single', component: RelacionesSanasCompText },
  };

  const doc = props.match.params.doc;

  const canvasSign = React.useRef(null);
  const parentCanvasSign = React.useRef(null);

  const form_verification = () => {
    let mandatoryInputs = ['fullName', 'identification'];

    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    errorInputs = errorInput({
      errorInputs,
      input: {
        name: 'sign',
        value: canvasSign.current && !canvasSign.current.isEmpty(),
      },
    });

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  async function sendForm(e) {
    if (form_verification()) return;

    const signature = canvasSign.current;
    if (!signature || signature.isEmpty()) {
      set_errorInputs((prev) => ({ ...prev, sign: true }));
      return;
    }

    const sign = JSON.stringify(signature.toData().flat());
    const parentSign = JSON.stringify(parentCanvasSign.current?.toData?.()?.flat?.() || []);

    set_sending(true);
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_sending(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    const body = {
      ...inputs,
      captcha,
      sign,
      parentSign,
      docName: doc,
      type: document?.[doc]?.type || '',
    };

    groupService
      .complianceForms(body)
      .then((response) => {
        if (response.data.success) {
          Swal.fire(response.data.message);
          setInputs({});
          canvasSign.current?.clear();
          parentCanvasSign.current?.clear();
        }
        set_sending(false);
      })
      .catch((error) => {
        set_sending(false);
        if (error) {
          console.log(error);
          Swal.fire(error?.response?.data?.message);
        }
      });
  }

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInputs({ ...inputs, [name]: value });
  };

  const input = ({ input, type = 'input', placeholder = '' }) => {
    return (
      <input
        type={type}
        name={input}
        placeholder={placeholder}
        className={`inline-form ${errorInputs[input] ? 'error' : ''}`}
        value={inputs[input] || ''}
        onChange={handleInputs}
      />
    );
  };

  const selectkindofid = () => {
    return (
      <select
        id="kind"
        onChange={(e) =>
          handleInputs({
            target: { value: e.target.value, name: 'kindofIdentification' },
          })
        }
        value={inputs.kindofIdentification}
      >
        <option value="C.C">C.C</option>
        <option value="C.E">C.E</option>
        <option value="T.I">T.I</option>
        <option value="PP">PP</option>
        <option value="PEP">PEP</option>
      </select>
    );
  };

  const today = new Date();
  return (
    <VolunteerRegistrationContainer>
      <h1>IGLESIA COMUNIDAD CRISTIANA DE FE Y VIENTO FRESCO</h1>
      <p className="nit">Nit. 811.000.923-5</p>
      <p className="personeria">
        Personería Jurídica Personería Jurídica Especial No. 2675 del 18 de Diciembre 1997 del
        Ministerio del Interior
      </p>
      <p className="exoneracion">
        En todos los casos y eventos se deberá firmar este documento de exoneración de
        responsabilidad civil, legal y administrativa, como requisito indispensable para participar
        en el encuentro, campamento o evento. En caso de que el participante sea un menor de edad o
        un persona con capacidades especiales, siempre debe contar con la respectiva autorización
        escrita de sus padres y/o tutor legal.
      </p>
      <GroupsComplianceForm input={input} selectkindofid={selectkindofid} />
      {document[doc].component()}
      <div className="inner">
        <div className="signs-form">
          <div className="volunteerSign acudiente">
            <div className="firstSign">
              <p>
                <strong>AUTORIZACIÓN PARA MENORES DE EDAD</strong>
              </p>
              <p>
                <i>
                  *La firma del padre, madre, acudiente y/o tutor legal es requerida si el
                  participante es menor de edad o es una persona con capacidades especiales.
                </i>
              </p>
              <p style={{ fontStyle: 'normal' }}>
                Nombres y apellidos del Padre y/o Tutor legal que autoriza la participación del
                menor o de la persona con capacidades especiales{' '}
                {input({ input: 'parentFullName', placeholder: 'Nombre completo' })}, con documento
                de identificación {selectkindofid()} No.{' '}
                {input({
                  input: 'parentIdentification',
                  type: 'number',
                  placeholder: 'Documento tutor',
                })}
              </p>
              <p style={{ fontStyle: 'normal', fontWeight: 'bold' }}>
                Firma del padre, madre, acudiente y/o tutor legal
              </p>
              <SignatureCanvas
                penColor="black"
                ref={parentCanvasSign}
                canvasProps={{
                  width: 300,
                  height: 200,
                  className: `sigCanvas  ${errorInputs['sign'] ? 'error' : ''}`,
                }}
              />
              <Button
                style={{ display: 'block', margin: ' 7px 0' }}
                size="mini"
                onClick={() => parentCanvasSign.current?.clear()}
              >
                Limpiar firma
              </Button>
            </div>
          </div>
          <p>
            Fecha de firma: <b>{today.getDate()}</b> del mes de{' '}
            <b>{today.toLocaleDateString('es-ES', { month: 'long' })}</b> de{' '}
            <b>{today.getFullYear()}</b>
          </p>
          <div className="volunteerSign">
            <div className="firstSign">
              <p style={{ fontStyle: 'normal', fontWeight: 'bold' }}>Firma participante</p>
              <SignatureCanvas
                penColor="black"
                ref={canvasSign}
                canvasProps={{
                  width: 300,
                  height: 200,
                  className: `sigCanvas  ${errorInputs['sign'] ? 'error' : ''}`,
                }}
              />
              <p>
                <strong>{inputs.fullName}</strong>
              </p>
              <p>{inputs.identification}</p>
              <Button
                style={{ display: 'block', margin: ' 7px 0' }}
                size="mini"
                onClick={() => canvasSign.current?.clear()}
              >
                Limpiar firma
              </Button>
            </div>

            <div className="actions">
              {Object.values(errorInputs).includes(true) && (
                <h4 style={{ color: 'red' }}>
                  Por favor verifica los campos obligatorios en rojo.
                </h4>
              )}
              {habeasData}
              <Button onClick={() => sendForm()} primary disabled={sending}>
                Enviar
              </Button>
            </div>
          </div>
        </div>
      </div>
    </VolunteerRegistrationContainer>
  );
};
export default GroupCompliance;
